import React from 'react';
import Joyride from 'react-joyride';
import { useContext } from 'react';
import TourContext from '../../context/TourContext';
import "./Tour.scss"
const TourConponent = () => {
    const { run, steps, handleJoyrideCallback, stepIndex }: any = useContext(TourContext);

    return <Joyride
        callback={handleJoyrideCallback}
        continuous
        showProgress={false}

        run={run}
        disableScrolling={true}
        // showProgress
        showSkipButton
        stepIndex={stepIndex}
        steps={steps}
        styles={{
            options: {
                zIndex: 10000,
            },
        buttonSkip:{
            fontFamily: "Source Sans Pro,sans-serif",
        },

            buttonBack: {
                // Custom styling for the back button
                color: '#4E4FA9',
                // background: 'white',
                border: "none",
                padding: '10px 20px',
                marginRight: '10px',
                cursor: 'pointer',
                fontFamily: "Source Sans Pro,sans-serif",

            },
            buttonNext: {
                // Custom styling for the next button
                background: '#4E4FA9',
                color: 'white',
                border: "1px solid #4E4FA9",
                fontFamily: "Source Sans Pro,sans-serif",
                cursor: 'pointer',
                padding: "6px",
                width:" 6rem",
                // #f3e9f3
            },
        }}
    />
};

export default TourConponent;